import { BaseModel } from "./base";

export class AutoInfracao extends BaseModel {
  constructor(
    public id: number,
    public numeroAitp: string,
    public placa: string,
    public dataLavratura: string,
    public descricao?: string,
    public valor?: number,
    public valorFormatado?: string
  ) {
    super(id);
  }
}
